(() => {
  // Prevent double init
  if (window.__cartDrawerFixInitV3) return;
  window.__cartDrawerFixInitV3 = true;

  const routes = (window.theme && window.theme.routes) ? window.theme.routes : {
    cart_add_url: '/cart/add',
    cart_change_url: '/cart/change',
    cart_update_url: '/cart/update',
    cart_url: '/cart',
    root_url: '/'
  };

  const drawerSelector = 'cart-drawer';

  const getDrawer = () => document.querySelector(drawerSelector);

  const cleanupLock = () => {
    document.documentElement.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden');

    // Hide overlays that may block clicks
    const overlays = document.querySelectorAll(
      '.cart-drawer__overlay, .drawer__overlay, .modal__overlay, .modal-overlay, [data-drawer-overlay], [data-overlay], .overlay'
    );
    overlays.forEach(el => {
      el.classList.remove('active');
      el.style.pointerEvents = 'none';
      // only hide if currently visible to prevent “dark screen stuck”
      if (getComputedStyle(el).display !== 'none') el.style.display = 'none';
    });
  };

  const openDrawer = () => {
    const d = getDrawer();
    if (!d) return;

    d.classList.add('active');
    document.documentElement.classList.add('overflow-hidden');
    document.body.classList.add('overflow-hidden');

    const overlay = document.querySelector('.cart-drawer__overlay, .drawer__overlay, [data-drawer-overlay], .overlay');
    if (overlay) {
      overlay.style.display = '';
      overlay.style.pointerEvents = 'auto';
      overlay.classList.add('active');
    }
  };

  const closeDrawer = () => {
    const d = getDrawer();
    if (d) d.classList.remove('active');
    cleanupLock();
  };

  const isDrawerOpen = () => {
    const d = getDrawer();
    return !!(d && d.classList.contains('active'));
  };

  // --- sections refresh ---
  async function fetchSections() {
    const url = `${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`;
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Sections fetch failed: ${res.status}`);
    return await res.json();
  }

  function extractInnerHTML(sectionHTML, tagName) {
    try {
      const doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
      const el = doc.querySelector(tagName);
      if (el) return el.innerHTML;
    } catch (_) {}
    return sectionHTML;
  }

  function updateCartBubble(sectionHTML) {
    // IMPORTANT: update only the bubble, never replace the cart icon container
    let newBubble = null;
    try {
      const doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
      newBubble =
        doc.querySelector('.cart-count-bubble') ||
        doc.querySelector('[data-cart-count-bubble]') ||
        doc.querySelector('.header__cart-count') ||
        null;
    } catch (_) {}

    if (!newBubble) return;

    const currentBubble =
      document.querySelector('.cart-count-bubble') ||
      document.querySelector('[data-cart-count-bubble]') ||
      document.querySelector('.header__cart-count') ||
      null;

    if (currentBubble) {
      currentBubble.outerHTML = newBubble.outerHTML;
      return;
    }

    // If bubble doesn't exist yet, try appending it near the cart icon
    const cartIcon =
      document.querySelector('.header__icon--cart') ||
      document.querySelector('a[href="/cart"]') ||
      document.querySelector('a[href^="/cart?"]') ||
      null;

    if (cartIcon) cartIcon.insertAdjacentHTML('beforeend', newBubble.outerHTML);
  }

  function renderSections(sections) {
    // Update drawer
    const d = getDrawer();
    if (d && sections['cart-drawer']) {
      const wasOpen = d.classList.contains('active');
      const html = extractInnerHTML(sections['cart-drawer'], drawerSelector);
      d.innerHTML = html;
      if (wasOpen) openDrawer();
    }

    // Update bubble safely (do NOT replace cart icon)
    if (sections['cart-icon-bubble']) {
      updateCartBubble(sections['cart-icon-bubble']);
    }
  }

  // --- user intent markers (more robust) ---
  let userInitiatedAdd = false;
  const markUserAdd = () => {
    userInitiatedAdd = true;
    setTimeout(() => { userInitiatedAdd = false; }, 2500);
  };

  // Mark add intent on clicks (covers many themes + sticky)
  document.addEventListener('click', (e) => {
    const el = e.target;
    const btnOrLink = el.closest?.('button, input[type="submit"], a, div');

    if (!btnOrLink) return;

    // Common ATC markers
    const looksLikeATC =
      btnOrLink.name === 'add' ||
      btnOrLink.getAttribute('data-add-to-cart') !== null ||
      btnOrLink.getAttribute('data-product-submit') !== null ||
      btnOrLink.className?.toLowerCase().includes('add-to-cart') ||
      btnOrLink.className?.toLowerCase().includes('product-form__submit') ||
      btnOrLink.className?.toLowerCase().includes('sticky') ||
      (btnOrLink.getAttribute('aria-label') || '').toLowerCase().includes('add') ||
      (btnOrLink.textContent || '').toLowerCase().includes('add to cart') ||
      (btnOrLink.textContent || '').includes('הוספה לסל');

    const form = btnOrLink.closest?.('form');
    const isProductForm = !!(form && (form.querySelector('input[name="id"]') || (form.getAttribute('action') || '').includes('/cart/add')));

    if (looksLikeATC || isProductForm) {
      markUserAdd();
    }
  }, true);

  // Mark add intent on submit (this is the key for themes that don’t have a classic button)
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    const action = (form.getAttribute('action') || '').toLowerCase();
    const isAdd =
      action.includes('/cart/add') ||
      !!form.querySelector('input[name="id"]');

    if (isAdd) markUserAdd();
  }, true);

  // --- Open drawer from cart icon click ---
  document.addEventListener('click', async (e) => {
    const trigger = e.target.closest(
      'a[href="/cart"], a[href^="/cart?"], [data-cart-drawer-open], [aria-label="Cart"], [aria-label="עגלת"], .header__icon--cart, .cart-link, .cart-icon'
    );
    if (!trigger) return;

    const d = getDrawer();
    if (!d) return;

    e.preventDefault();

    try {
      const sections = await fetchSections();
      renderSections(sections);
      openDrawer();
    } catch (_) {
      openDrawer();
    }
  }, true);

  // --- Close handlers ---
  document.addEventListener('click', (e) => {
    const d = getDrawer();
    if (!d) return;

    const closeBtn = e.target.closest(
      '[data-cart-drawer-close], .drawer__close, .cart-drawer__close, button[aria-label="Close"], button[aria-label="סגור"]'
    );
    const overlay = e.target.closest('.cart-drawer__overlay, .drawer__overlay, [data-drawer-overlay], .modal-overlay, .overlay');

    if (closeBtn || overlay) {
      e.preventDefault();
      closeDrawer();
    }
  }, true);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isDrawerOpen()) closeDrawer();
  });

  // --- Patch fetch to detect /cart/add and /cart/change ---
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const res = await originalFetch(...args);

    try {
      const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
      const method = (args[1]?.method || 'GET').toUpperCase();

      const isAdd =
        method === 'POST' &&
        (url.includes('/cart/add') || url.includes('/cart/add.js'));

      const isChange =
        method === 'POST' &&
        (url.includes('/cart/change') || url.includes('/cart/change.js') || url.includes('/cart/update') || url.includes('/cart/update.js'));

      if (res.ok && (isAdd || isChange)) {
        const sections = await fetchSections();
        renderSections(sections);

        // Open drawer after add (only when user initiated)
        if (isAdd && userInitiatedAdd) {
          openDrawer();
        }
      }
    } catch (_) {}

    return res;
  };

  // Safety cleanup on navigation/back-forward
  window.addEventListener('pageshow', cleanupLock);
})();